import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { StoreState } from '~/reducer';
import { userSettingsStoreStateSelector } from '~/selectors';

export const useUserSettings = <T extends object>(
  resolveUserSettings: (remoteUserSettings: Partial<T> | undefined) => T,
  key: string,
): { personalWorkspaces: T; hasDataPersonalWorkspaces: boolean } => {
  const rawUserSettings = useSelector((state: StoreState) => {
    const selectorState =
      userSettingsStoreStateSelector(state).userSettings[key];

    return { rawData: selectorState?.data, hasData: !selectorState?.hasData };
  });

  const data = useMemo(() => {
    return resolveUserSettings(rawUserSettings.rawData);
  }, [resolveUserSettings, rawUserSettings]);

  return {
    personalWorkspaces: data,
    hasDataPersonalWorkspaces: rawUserSettings.hasData,
  };
};
